export default __webpack_public_path__ + "static/media/buster_klein_13.8139039b.jpg";